<div class="madar--v2">
  <mat-card class="stats-card" [class]="'stats-card__' + theme" [class.stats-card_inverted]="inverted">
    <mat-card-content>
      <app-row align="center" gutter="sm">
        <app-col cols="auto">
          <div class="stats-card__icon">
            <ng-content select="[icon], mat-icon, .icon, svg-icon, app-icon"></ng-content>
          </div>
        </app-col>
        <app-col class="flex column">
          <div>
            <span class="stats-card__title">
              <ng-content select="[title]"></ng-content>
            </span>
            <span class="stats-card__title-suffix ml-1" #suffixElement [hidden]="!suffixElement.childNodes.length">
              <ng-content select="[suffix]"></ng-content>
            </span>
          </div>
          <div class="flex align-center">
            <span class="stats-card__subtitle">
              <ng-content select="[subtitle]"></ng-content>
            </span>
            <span class="line-height">
              <ng-content select="[subtitle-icon]"></ng-content>
            </span>
          </div>
        </app-col>
      </app-row>
      <div class="stats-card__ribbon" [hidden]="!ribbonElement.childNodes.length">
        <div class="stats-card__shape"></div>
        <div class="stats-card__ribbon-text" #ribbonElement>
          <ng-content select="[ribbon]"></ng-content>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
